import React, { useContext, useMemo } from 'react';

import useTaskList from '../../../utils/hooks/use_task_list';

const TaskListDataContext = React.createContext({
  error: null,
  loading: false,
  taskListData: [],
});

export const TaskListDataContextProvider = ({ orchSha, children }) => {
  const { taskListData, loading, error } = useTaskList({ orchSha });

  const dataContextValue = useMemo(() => ({
    taskListData,
    loading,
    error,
  }), [
    taskListData,
    loading,
    error,
  ])

  return (
    <TaskListDataContext.Provider
      value={dataContextValue}
    >
      { children }
    </TaskListDataContext.Provider>
  )
};

export const useTaskListData = () => useContext(TaskListDataContext)

export default useTaskListData;
